module.exports = __webpack_public_path__ + "img/logo-dark.59b888ac.svg";